import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
export const AnnouncementBanner = ({ pcBannerImgPath, spBannerImgPath, linkPath, dataTest }) => {
    const isSM = useSmMediaQuery();
    const imgPath = isSM ? spBannerImgPath : pcBannerImgPath;
    return (React.createElement(Link, { to: linkPath, "data-test": dataTest },
        React.createElement("img", { src: imgPath, className: css(styles.announcementImg) })));
};
const styles = StyleSheet.create({
    announcementImg: {
        width: '100%',
        borderRadius: 4,
    },
});
